import styled from "styled-components";
import { media } from "../../styles/mixins";
import { CONTAINER_WIDTHS } from "../../assets/constants/styles";

export const FullWidthSection = styled.section`
  width: 100vw;
  margin-left: calc(-50vw + 50%);
  position: relative;
  background: ${(props) => props.$background || "transparent"};
  // padding: ${(props) => props.$padding || "40px 0"};
  z-index: 0;
  overflow: hidden;
`;

export const ContentContainer = styled.div`
  width: 100%;
  margin: auto;
  max-width: ${CONTAINER_WIDTHS.mobile}px;

  ${media.tablet(`max-width: ${CONTAINER_WIDTHS.tablet}px;`)}
  ${media.laptop(`max-width: ${CONTAINER_WIDTHS.laptop}px;`)}
  ${media.desktop(`max-width: ${CONTAINER_WIDTHS.desktop}px;`)}
`;

export const FullWidthSectionWithContent = ({
  background,
  padding,
  children,
}) => (
  <FullWidthSection $background={background} $padding={padding}>
    <ContentContainer>{children}</ContentContainer>
  </FullWidthSection>
);
